var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import * as React from 'react';
import tabbable from 'tabbable';
import classNames from 'classnames';

var FocusTrap = function (_React$Component) {
    _inherits(FocusTrap, _React$Component);

    function FocusTrap() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, FocusTrap);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FocusTrap.__proto__ || Object.getPrototypeOf(FocusTrap)).call.apply(_ref, [this].concat(args))), _this), _this.focusFirstElement = function () {
            if (!_this.el) {
                return;
            }

            var tabbableEls = tabbable(_this.el);

            // There are three trap-related elements, including first element.
            // If there are 3 or fewer tabbable elements, that means there are no
            // tabbable children, so focus on the trap element instead.
            if (tabbableEls.length > 3) {
                tabbableEls[1].focus();
            } else if (_this.trapEl) {
                _this.trapEl.focus();
            }
        }, _this.focusLastElement = function () {
            if (!_this.el) {
                return;
            }

            var tabbableEls = tabbable(_this.el);

            // There are three trap-related elements, including the last two elements.
            // If there are 3 or fewer tabbable elements, that means there are no
            // tabbable children, so focus on the trap element instead.
            if (tabbableEls.length > 3) {
                tabbableEls[tabbableEls.length - 3].focus();
            } else if (_this.trapEl) {
                _this.trapEl.focus();
            }
        }, _this.handleElKeyDown = function (event) {
            var handleOverlayKeyDown = _this.props.handleOverlayKeyDown;

            if (_this.el === document.activeElement && event.key === 'Tab') {
                _this.focusFirstElement();
                event.stopPropagation();
                event.preventDefault();
            }

            if (handleOverlayKeyDown) {
                handleOverlayKeyDown(event);
            }
        }, _this.handleTrapElKeyDown = function (event) {
            if (event.key !== 'Tab') {
                return;
            }
            event.stopPropagation();
            event.preventDefault();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(FocusTrap, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            if (this.props.shouldDefaultFocus) {
                setTimeout(function () {
                    _this2.previousFocusEl = document.activeElement;
                    _this2.focusFirstElement();
                }, 0);
            } else {
                setTimeout(function () {
                    if (_this2.el) {
                        _this2.el.focus();
                    }
                }, 0);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var _this3 = this;

            setTimeout(function () {
                if (_this3.previousFocusEl) {
                    _this3.previousFocusEl.focus();
                }
            }, 0);
        }

        /**
         * Focus the first tabbable element
         */


        /**
         * Focus the last tabbable element
         */

    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _props = this.props,
                children = _props.children,
                className = _props.className,
                getRef = _props.getRef,
                handleOverlayKeyDown = _props.handleOverlayKeyDown,
                shouldDefaultFocus = _props.shouldDefaultFocus,
                shouldOutlineFocus = _props.shouldOutlineFocus,
                rest = _objectWithoutProperties(_props, ['children', 'className', 'getRef', 'handleOverlayKeyDown', 'shouldDefaultFocus', 'shouldOutlineFocus']);

            return React.createElement(
                'div',
                _extends({
                    className: classNames(className, {
                        'should-outline-focus': shouldOutlineFocus
                    }),
                    ref: function ref(_ref3) {
                        _this4.el = _ref3;
                        if (getRef) {
                            getRef(_ref3);
                        }
                    },
                    onKeyDown: this.handleElKeyDown
                }, rest),
                React.createElement('i', { 'aria-hidden': true, tabIndex: '0', onFocus: this.focusLastElement }),
                children,
                React.createElement('i', { 'aria-hidden': true, tabIndex: '0', onFocus: this.focusFirstElement }),
                React.createElement('i', {
                    'aria-hidden': true,
                    ref: function ref(_ref2) {
                        _this4.trapEl = _ref2;
                    },
                    tabIndex: '0',
                    onKeyDown: this.handleTrapElKeyDown
                })
            );
        }
    }]);

    return FocusTrap;
}(React.Component);

FocusTrap.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,

    /** Function to get the ref to the focus trap wrapper element */
    getRef: PropTypes.func,

    /** Function to handle keyboard input passed in from parent component. e.g. close overlay on Escape */
    handleOverlayKeyDown: PropTypes.func,
    shouldDefaultFocus: PropTypes.bool,
    shouldOutlineFocus: PropTypes.bool
};


export default FocusTrap;
import PropTypes from 'prop-types';